package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.FixProduct
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px

@Composable
fun AddOrEditFixedProductDialog(
    title: String,
    articles: List<ProductItem>,
    selectedFixedProduct: FixProduct?,
    loading: Boolean,
    onDismissDialog: () -> Unit,
    submit: (String, Double?, Int) -> Unit,
) {

    val selectedProductItem = remember {
        mutableStateOf<ProductItem?>(
            articles.find {
                selectedFixedProduct?.code==it.id

            }
        )
    }

    val quantity = remember {
        mutableStateOf(selectedFixedProduct?.amount?.toString()?:"")
    }

    val price = remember {
        mutableStateOf(selectedFixedProduct?.price?.toString()?:"")
    }

    val isFormValid = selectedProductItem.value != null &&
            quantity.value.isNotEmpty()

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onDismissDialog()
            }
    ) {
        Column(
            modifier = Modifier
                .onClick { event: SyntheticMouseEvent -> event.stopPropagation() }
                .align(Alignment.Center)
                .backgroundColor(Theme.White.rgb)
                .zIndex(1)
                .boxShadow(
                    color = Theme.ActionDisabledBackground.rgb,
                    blurRadius = Dimen.smallBlurRadius,
                )
                .borderRadius(r = Dimen.semiLargeRadius),
            horizontalAlignment = Alignment.Start
        ) {
            DialogTitle(
                title = title,
                showCloseIcon = true,
                showSeparator = false,
                onCloseClick = {
                    onDismissDialog()
                },
            )

            Column(
                Modifier
                    .width(Dimen.addOrEditFixedProductWidth)
                    .padding(
                        leftRight = Dimen.extraLargePadding,
                        bottom = Dimen.extraLargePadding,
                    )
            ) {
                DropDownItem(
                    modifier = Modifier
                        .margin(bottom = Dimen.highLargePadding),
                    options = articles,
                    fillMaxWidth = true,
                    label = Strings.current().article,
                    itemWidth = Dimen.semiLargeEditTextWidth,
                    selectedItem = selectedProductItem.value,
                    displayText = {
                        if (it is ProductItem)
                            it.name ?: ""
                        else ""
                    },
                    onOptionClick = {
                        if (it is ProductItem){
                            selectedProductItem.value = it
                        }

                    },
                )

                Row(
                    modifier = Modifier
                        .margin(bottom = Dimen.extraLargePadding)
                        .fillMaxWidth()
                ) {
                    CustomEditText(
                        value = quantity.value,
                        label = Strings.current().quantity,
                        marginRight = Dimen.largePadding,
                        fillMaxWidth = true,
                        marginBottom = 0.px,
                        onFocusOut = {},
                        inputType = InputType.Number,
                        onFocusIn = {},
                        onInputChange = { newValue, _ ->
                            quantity.value = newValue
                        },
                    )

                    CustomEditText(
                        value = price.value?:"",
                        label = Strings.current().price,
                        fillMaxWidth = true,
                        isDecimal = true,
                        isRequired = false,
                        marginBottom = 0.px,
                        onFocusOut = {},
                        onFocusIn = {},
                        onInputChange = { newValue, _ ->
                            price.value = newValue
                        },
                    )
                }

                CustomButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    buttonType = ButtonTypes.CONTAINED,
                    title = Strings.current().submit,
                    loading = loading,
                    isClickable = isFormValid,
                    onButtonClick = {
                        submit(
                            selectedProductItem.value?.id?:"",
                            if (price.value.isEmpty()) null else
                                price.value.toDouble(),
                            quantity.value.toInt(),
                        )
                    }
                )
            }
        }
    }
}